<template>
  <div :class="fitParent ? 'h-full w-full' : 'fixed top-0 bottom-0 left-0 right-0'">
    <div
      class="flex flex-col items-center justify-center"
      :class="fitParent ? 'h-full w-full' : 'h-screen w-screen'"
      :style="{ background: fitParent ? undefined : themeVars.base }"
    >
      <NSpin :color="themeVars.primary" size="large" />
      <div v-if="loadingTexts?.length" class="mt-2 text-lg" :style="{ color: themeVars.text2 }">
        {{ loadingTexts[currentTextIndex] }}
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { NSpin } from 'naive-ui'
import { ref, onMounted, onUnmounted } from 'vue'

import useThemeVars from '@lib/composables/useThemeVars'

const props = withDefaults(
  defineProps<{
    interval?: number
    loadingTexts?: string[]
    fitParent?: boolean
  }>(),
  {
    interval: 2000,
    loadingTexts: () => [],
    fitParent: false,
  },
)
const themeVars = useThemeVars()
const currentTextIndex = ref(0)
let intervalId: ReturnType<typeof setInterval>

function rotateText() {
  if (props.loadingTexts?.length && currentTextIndex.value < props.loadingTexts.length - 1) {
    currentTextIndex.value++
  }
}

onMounted(() => {
  intervalId = setInterval(rotateText, props.interval)
})

onUnmounted(() => {
  clearInterval(intervalId)
})
</script>
